import httpUserClient from '@/plugins/httpUserClient';

export default {
  getTrainList() {
    return httpUserClient.get('user/train/entries');
  },
  showTrain(id) {
    return httpUserClient.get(`train/activities/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/userApis/train/trainApi.js